(function () {
  const SEPARATORS = {
    amount: { thousands: ',', decimal: '.' },
    amount_with_comma_separator: { thousands: '.', decimal: ',' },
    amount_with_space_separator: { thousands: ' ', decimal: ',' },
    amount_with_apostrophe_separator: { thousands: "'", decimal: '.' },
    amount_with_period_and_space_separator: { thousands: ' ', decimal: '.' },
  };

  function formatAmount(cents, token) {
    const hasDecimals = !token.includes('_no_decimals');
    const { thousands, decimal } = SEPARATORS[token.replace('_no_decimals', '')] || SEPARATORS.amount;
    const [whole, fraction] = (cents / 100).toFixed(hasDecimals ? 2 : 0).split('.');
    const groupedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return hasDecimals ? groupedWhole + decimal + fraction : groupedWhole;
  }

  globalThis.formatShopifyMoney = function (price, moneyFormat) {
    const cents = typeof price === 'number' ? price : parseInt(price, 10);
    if (!cents) return '';
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (match, token) => formatAmount(cents, token));
  };
})();
